export default "__VITE_ASSET__COMVBpHo__"